export const LOAD_TAGS = 'tags/LOAD_TAGS';
export const ADD_TAG = 'tags/ADD_TAG';
export const UPDATE_TAG = 'tags/UPDATE_TAG';
export const DELETE_TAG = 'tags/DELETE_TAG';
